import React, { useCallback, useState } from "react";
import { AcceptedDocumentDialog } from "./AcceptedDocumentDialog";
import { requiredDocList } from "../constants";
import { StyledTwoStepGroup, StyledAcceptedDocBtn, StyledDivider } from "./styled";

export const TwoSteps = () => {
  const [open, setOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardClickOpenDialog = card => {
    setOpen(true);
    setSelectedCard(card);
  };

  const handleOnCloseDocDialog = useCallback(() => {
    setOpen(false);
    setSelectedCard("");
  }, [open]);

  return (
    <>
      <StyledTwoStepGroup>
        <div className="cardsWrapper">
          <p className="cardsTitle"> Required documents</p>
          {requiredDocList.map((card, index) => (
            <React.Fragment key={card.alt}>
              <StyledDivider />
              <div className="cards" data-testid={`two-steps-card-${index}`}>
                <div className="cardsDetails">
                  <card.Icon alt={card.alt} />
                  <p className="cardDesc">{card.description}</p>
                </div>
                {card.showButton && (
                  <StyledAcceptedDocBtn
                    variant="text"
                    onClick={() => handleCardClickOpenDialog(card)}
                    data-testid="accepted-doc-btn"
                  >
                    Accepted documents
                  </StyledAcceptedDocBtn>
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
      </StyledTwoStepGroup>
      <AcceptedDocumentDialog
        open={open}
        title={selectedCard?.description}
        listOfAcceptedDoc={selectedCard?.acceptedDocs}
        docImage={selectedCard?.docImage}
        handleClose={handleOnCloseDocDialog}
        type={selectedCard?.alt}
        modalTitle={selectedCard?.modalTitle}
      />
    </>
  );
};
